import { getRequest, postRequest, putRequest, URL } from "shared/utils";

import * as types from "./actionTypes";

const queryParms = (request) => {
  const { searchKeyword, filters } = request;

  let parms = "?";

  if (searchKeyword) {
    parms += `&searchKeyword=${searchKeyword}`;
  }

  if (filters) {
    Object.keys(filters).forEach((key) => {
      var filterBy = filters[key];

      if (key === "isPortfolioClient" && filterBy) {
        parms += `&${key}=true`;
      }

      if (filterBy && filterBy.length > 0) {
        filterBy.forEach((f) => {
          parms += `&${key}=${f}`;
        });
      }
    });
  }

  return parms;
};

export function getClients(requestWithParams) {
  const url = `${URL.client}${queryParms(requestWithParams)}`;

  const request = getRequest(url, null);

  return {
    type: types.GET_CLIENTS,
    payload: request,
  };
}

export function setSelectedClientId(clientId) {
  const payload = { selectedClientId: clientId };

  return {
    type: types.SET_SELECTED_CLIENT_ID,
    payload,
  };
}

export function setSelectedClient(client) {
  const payload = { selectedClient: client };

  return {
    type: types.SET_SELECTED_CLIENT,
    payload,
  };
}

export function getClient(clientId) {
  const url = `${URL.client}/${clientId}`;

  const request = getRequest(url, null);

  return {
    type: types.GET_CLIENT,
    payload: request,
  };
}

export function getClientByOVCId(ovcId) {
  const url = `${URL.client}/byOvcId/${ovcId}`;

  const request = getRequest(url, null);

  return {
    type: types.GET_CLIENT_BY_OVCID,
    payload: request,
  };
}

export function getClientsUsers(clientId) {
  const url = `${URL.client}/${clientId}/users`;

  const request = getRequest(url, null);

  return {
    type: types.GET_CLIENTS_USERS,
    payload: request,
  };
}

export function getClientsUserRoles(clientId) {
  const url = `${URL.client}/${clientId}/userRoles`;

  const request = getRequest(url, null);

  return {
    type: types.GET_CLIENTS_USER_ROLES,
    payload: request,
  };
}

export function insertClient(clientData) {
  const url = URL.client;

  const request = postRequest(url, clientData);

  return {
    type: types.INSERT_CLIENT,
    payload: request,
  };
}

export function updateClient(clientData) {
  const url = URL.client;

  const request = putRequest(url, clientData);

  return {
    type: types.UPDATE_CLIENT,
    payload: request,
  };
}

export function archiveClient(id, modifiedBy) {
  const url = `${URL.client}/${id}/archive?modifiedBy=${modifiedBy}`;

  const request = putRequest(url);

  return {
    type: types.UPDATE_CLIENT,
    payload: request,
  };
}

export function unarchiveClient(id, modifiedBy) {
  const url = `${URL.client}/${id}/unarchive?modifiedBy=${modifiedBy}`;

  const request = putRequest(url);

  return {
    type: types.UPDATE_CLIENT,
    payload: request,
  };
}

export function updateClientsUser(clientUserData) {
  const url = `${URL.client}/user`;

  const request = putRequest(url, clientUserData);

  return {
    type: types.UPDATE_CLIENTS_USER,
    payload: request,
  };
}

export function archiveClientsUser(clientUserData) {
  const url = `${URL.client}/user/archive`;

  const request = putRequest(url, clientUserData);

  return {
    type: types.UPDATE_CLIENTS_USER,
    payload: request,
  };
}

export function unarchiveClientsUser(clientUserData) {
  const url = `${URL.client}/user/unarchive`;

  const request = putRequest(url, clientUserData);

  return {
    type: types.UPDATE_CLIENTS_USER,
    payload: request,
  };
}

export function insertClientsUser(clientUserData) {
  const url = `${URL.client}/user`;

  const request = postRequest(url, clientUserData);

  return {
    type: types.INSERT_CLIENTS_USER,
    payload: request,
  };
}

export function saveClientsUserRoles(regionRoles) {
  const url = `${URL.client}/userRoles`;

  const request = postRequest(url, regionRoles);

  return {
    type: types.SAVE_CLIENT_ROLES,
    payload: request,
  };
}
